import { useNavigate } from "react-router-dom";
import { Clock, LogIn } from "lucide-react";

export default function SessionExpired() {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-10">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-lg border border-gray-200 p-8 text-center shadow-md">
          <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6">
            <Clock className="w-8 h-8 text-blue-600" />
          </div>

          <h1 className="text-2xl font-semibold text-gray-900 mb-2">
            Session Expired
          </h1>
          <p className="text-xs text-gray-400 uppercase tracking-wider mb-4">
            Security Logout
          </p>
          
          <p className="text-sm text-gray-600 mb-6 leading-relaxed">
            Your login session has ended or expired. To protect your data, you have been automatically logged out. Please log back in to continue.
          </p>

          <button
            onClick={handleLoginRedirect}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium shadow-sm transition-colors duration-150"
          >
            <LogIn className="w-4 h-4" />
            Log In Again
          </button>
          
          <p className="text-[11px] text-gray-400 mt-6">
            If you continue to experience issues, please contact support.
          </p>
        </div>
      </div>
    </div>
  );
}
